import { Cube20Regular, Info20Regular } from '@fluentui/react-icons';
import { createModuleConfig } from '../createModuleConfig';
import { lazyPage } from '../lazyPage';

const WorkersOverviewPage = lazyPage(() => import('./tools/overview/pages/OverviewPage'));
const WorkersDetailsPage = lazyPage(() => import('./tools/details/pages/DetailsPage'));

const workersModuleConfig = createModuleConfig({
  key: 'workers',
  name: 'Workers',
  domain: { title: 'Workers', icon: Cube20Regular },
  tools: [
    { 
      key: 'overview',
      name: 'Overview',
      title: 'Workers Overview',
      path: '/workers', 
      element: <WorkersOverviewPage />, 
      nav: { name: 'Overview', icon: Cube20Regular }
    },
    { 
      key: 'details',
      name: 'Details',
      title: 'Worker Details',
      path: '/workers/details', 
      element: <WorkersDetailsPage />, 
      nav: { name: 'Details', icon: Info20Regular }
    },
  ],
});

export default workersModuleConfig;
